import {
  deserializeYesplanAPIDate,
  serializeYesplanAPIDate
} from '../libs/dateTimeUtilities';
import { hashString } from '../libs/stringHashing';
import AbstractNotification from './YPAbstractNotificationObject';

export default class PublishOrRevokeNotification extends AbstractNotification {
  constructor(id, timestamp, isRead, notificationMessage, changes) {
    super(id, timestamp, isRead, notificationMessage, changes);
    this.changes = changes;
    this.#setIsRevokeNotification();
    this.dateObjects = notificationMessage.notificationDates.map((dateString) =>
      deserializeYesplanAPIDate(dateString)
    );
  }

  #setIsRevokeNotification() {
    this.newRosterPublishedUntilDate = deserializeYesplanAPIDate(this.changes[0].new).add(
      -1,
      'd'
    );
    this.oldRosterPublishedUtilDate = deserializeYesplanAPIDate(this.changes[0].old).add(
      -1,
      'd'
    );
    this.revokeNotification = this.newRosterPublishedUntilDate.isBefore(
      this.oldRosterPublishedUtilDate
    );
  }

  getNotificationText() {
    return this.notificationMessage.notificationText;
  }

  getNotificationIdWithMessageHash() {
    const hashedMessage = hashString(this.notificationMessage.notificationText);
    return `${this.id}-${hashedMessage}`;
  }

  getNotificationMessageDates() {
    return this.dateObjects;
  }

  isRevokeNotification() {
    return this.revokeNotification;
  }

  getDateStringForRosterURL() {
    if (this.isRevokeNotification())
      return serializeYesplanAPIDate(this.newRosterPublishedUntilDate);

    return serializeYesplanAPIDate(this.oldRosterPublishedUtilDate.clone().add(1, 'd'));
  }

  isPublishOrRevokeNotification() {
    return true;
  }

  getPath() {
    return 'rosterNotifications';
  }

  getNotifications(rosterNotifications, updateNotifications, timesheetNotifications) {
    return rosterNotifications;
  }
}
